
import { defineComponent, PropType } from "vue";

import Resource from "@/models/Resource";

export default defineComponent({
  props: {
    resource: { type: String as PropType<Resource>, required: true },
  },
});
